import '../../style/base.css';
import '../../overlay/index.css';
import '../../info/index.css';
import '../../icon/index.css';
import '../../image/index.css';
import '../../popup/index.css';
import '../../loading/index.css';
import '../../swipe/index.css';
import '../../swipe-item/index.css';
import '../../image-preview/index.css';
import '../index.css';


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/uploader/style/index.js
// module id = 440
// module chunks = 0